import React from 'react'
import BaseIcon from 'react-icon-base'

const RU = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <defs>
      <rect id="ru_svg__a" width={21} height={15} rx={2} />
      <rect id="ru_svg__d" width={20} height={14} x={0.5} y={0.5} rx={1} />
      <filter id="ru_svg__b" width="104.8%" height="106.7%" x="-2.4%" y="-3.3%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius={1} result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121659873 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ru_svg__c" fill="#fff">
        <use xlinkHref="#ru_svg__a" />
      </mask>
      <use fill="#2E5BB3" xlinkHref="#ru_svg__a" />
      <use fill="#000" filter="url(#ru_svg__b)" xlinkHref="#ru_svg__a" />
      <path fill="#CF2338" d="M0 10h21v5H0z" mask="url(#ru_svg__c)" />
      <path fill="#FFF" d="M0 0h21v5H0z" mask="url(#ru_svg__c)" />
      <use stroke="#2F343A" strokeOpacity={0.157} xlinkHref="#ru_svg__d" />
    </g>
  </BaseIcon>
)

export default RU
